import { useSelector } from "react-redux";

import AArsrapportExcel from "./AArsrapportExcel";

function AArsrapportExcelContainer(ownProps) {
  const aarsrapport = useSelector((state) => state.rapporter.aarsrapport);
  const aarsrapportSubmittedForm = useSelector(
    (state) => state.submittedForms.aarsrapportSubmittedForm,
  );

  return (
    <AArsrapportExcel
      {...ownProps}
      aarsrapport={aarsrapport}
      aarsrapportSubmittedForm={aarsrapportSubmittedForm}
    />
  );
}

export default AArsrapportExcelContainer;
